import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

type ContributionBackLineProps = {
  label: ReactNode;
  onClick: () => void;
  className?: string;
};

export function ContributionBackLine({ label, onClick, className }: ContributionBackLineProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        'group inline-flex w-fit items-center gap-3 text-[0.72rem] font-semibold uppercase tracking-[0.2em] text-muted-foreground/75 transition-colors hover:text-foreground focus-visible:outline-none focus-visible:ring-0',
        className,
      )}
    >
      <span>{label}</span>
    </button>
  );
}
